import { render, staticRenderFns } from "./jobseekerPreReg.html?vue&type=template&id=1606bf6e&scoped=true&external"
import script from "./jobseekerPreReg.vue?vue&type=script&lang=ts"
export * from "./jobseekerPreReg.vue?vue&type=script&lang=ts"
import style0 from "./jobseekerPreReg.scss?vue&type=style&index=0&id=1606bf6e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1606bf6e",
  null
  
)

export default component.exports